module.exports = __webpack_public_path__ + "static/media/tokenomics-right.d9d41d71.png";